import Splide from '@splidejs/splide';

let productMainSlider = document.getElementsByClassName('product_main_slider');
let productThumbnails = document.getElementsByClassName('product_thumbnail_slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < productMainSlider.length; i++) {
        let main = new Splide(productMainSlider[i], {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: true,
            width: '100%'
        });

        let thumbs = new Splide(productThumbnails[i], {
            type: 'slide',
            perPage: 4,
            perMove: 1,
            rewind: false,
            gap: 8,
            pagination: false,
            arrows: false,
            isNavigation: true,
            width: '100%'
        });

        //Count total thumbnails
        let totalThumbs = productThumbnails[i].getElementsByTagName('li').length;
        let indicatorNumber = totalThumbs - 4;

        //Check if the indicator needs to be created
        if (totalThumbs > 4) {
            let newIndicator = document.createElement('div');
            newIndicator.classList.add('indicator');
            newIndicator.innerText = '+' + indicatorNumber;
            productThumbnails[i].insertBefore(newIndicator, productThumbnails[i].querySelector('.splide__track'));

            //Remove indicator when clicked
            newIndicator.addEventListener('click', function () {
                this.remove();
            });

            //If indicator is visible remove it when slider is moved
            if (newIndicator) {
                main.on('moved', function () {
                    newIndicator.remove();
                });
            }
        }

        main.sync(thumbs);
        main.mount();
        thumbs.mount();
    }

    //Skip intro
    document.querySelector('.js-skip-intro').addEventListener('click', function (e) {
        e.preventDefault();
        document.getElementById('skip-intro').scrollIntoView(
            {behavior: 'smooth'}
        );
    })

});
